import { Tooltip, Typography } from '@mui/material'

interface ContentTagChipsProps {
  tags?: string[] | null
  className?: string
  limit?: number
}

const ContentTagChips = ({ tags, className = '', limit }: ContentTagChipsProps) => {
  if (!tags?.length) return null
  const visibleTags = limit ? tags.slice(0, limit) : tags
  const hiddenTags = tags.slice(visibleTags.length)
  return (
    <div className={`flex items-center gap-2 ${limit ? 'flex-nowrap' : 'flex-wrap'} ${className}`}>
      {visibleTags.map(tag => (
        <span key={tag} className="inline-flex -skew-x-12 bg-secondary-gray rounded-sm px-2 py-0.5">
          <Typography variant="chipLabel" color="text.primary" className="inline-block skew-x-12">
            {tag}
          </Typography>
        </span>
      ))}
      {hiddenTags.length > 0 && (
        <Tooltip title={hiddenTags.join(' & ')}>
          <Typography variant="chipLabel" color="text.primary">
            +{hiddenTags.length}
          </Typography>
        </Tooltip>
      )}
    </div>
  )
}

export default ContentTagChips
